(() => {
    const body         = document.querySelector('body');
    const header       = document.querySelector('.header-container');
    const topBar       = document.querySelector('.topbar-container');
    const burgerButton = header.querySelector('.header-hamburger');
    const closeButton  = header.querySelector('.header-close');
    const navMenu      = header.querySelector('.header-menu');
    const searchButton = header.querySelector('.search-form .btn');
    const searchField  = header.querySelector('.search-form input[type="text"]');
    const cartButton   = header.querySelector('.effect-open_cart');
    const cartDropdown = header.querySelector('.dropdown-cart');

    const toggleMobileNav = () => {
        navMenu.classList.toggle('active');
        navMenu.style.top = `${topBar.offsetHeight + header.offsetHeight}px`;
        burgerButton.classList.toggle('show');
        closeButton.classList.toggle('show');
        body.classList.toggle('oh');
    };

    const toggleSearch = (e) => {
        if (searchField.value === '') {
            e.preventDefault();

            searchField.classList.toggle('active');
        }
    };

    const toggleMobileCart = () => {
        const cart = header.querySelector('.dropdown-cart');

        cart.style.top = `${topBar.offsetHeight + header.offsetHeight}px`;
        cart.querySelector('.btn-close').addEventListener('click', toggleMobileCart);

        if (window.innerWidth < 768) {
            body.classList.toggle('oh');
        }
    };

    burgerButton.addEventListener('click', toggleMobileNav);
    closeButton.addEventListener('click', toggleMobileNav);
    searchButton.addEventListener('click', toggleSearch);
    cartButton.addEventListener('click', toggleMobileCart);

    globalThis.addEventListener('resize', () => {
        const cart = header.querySelector('.dropdown-cart');

        if (window.innerWidth < 1200) {
            navMenu.style.top = `${topBar.offsetHeight + header.offsetHeight}px`;
        }

        if (cart) {
            cart.style.top = `${topBar.offsetHeight + header.offsetHeight}px`;
        }
    });
})();